import { Reveal } from "@/components/common";
import { VimeoPlayer } from "@/components/VimeoPlayer";
import { useI18n } from "@/i18n";

function Label({ children, accent }) {
  return (
    <span className={`absolute left-3 top-3 z-10 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider shadow ${accent ? "bg-gradient-red text-white" : "bg-white text-re-ink"}`}>
      {children}
    </span>
  );
}

export function BeforeAfter() {
  const { t } = useI18n();
  return (
    <section id="voor-en-na" className="overflow-visible bg-re-soft/60 py-24 md:py-32" data-testid="before-after">
      <div className="container-re">
        <Reveal className="mx-auto max-w-2xl px-2 text-center">
          <h2 className="pb-1 font-heading text-3xl font-black leading-[1.12] tracking-tight text-re-ink md:text-5xl">
            {t("beforeAfter.title")} <span className="text-gradient-red">{t("beforeAfter.titleAccent")}</span>.
          </h2>
          <p className="mt-5 text-base text-re-muted md:text-lg">
            {t("beforeAfter.sub")}
          </p>
        </Reveal>

        {/* GROUP 1 — HORIZONTAL */}
        <Reveal className="mx-auto mt-14 max-w-5xl">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-re-muted">{t("beforeAfter.horizontal")}</p>
          <div className="grid gap-6 md:grid-cols-2 md:gap-8">
            <figure className="relative overflow-hidden rounded-3xl border border-re-line bg-white shadow-premium">
              <Label>{t("beforeAfter.before")}</Label>
              <div className="aspect-video w-full">
                <img src="/example-horizontal.webp" alt="" loading="lazy" className="h-full w-full object-cover object-center" />
              </div>
            </figure>
            <figure className="group/na relative">
              <div className="pointer-events-none absolute -inset-3 rounded-[2rem] bg-gradient-red opacity-[0.12] blur-2xl" />
              <div className="relative overflow-hidden rounded-3xl border border-re-line bg-white shadow-premium">
                <Label accent>{t("beforeAfter.after")}</Label>
                <div className="marketing-video-frame marketing-video-frame--horizontal">
                  <VimeoPlayer videoId="1218312340" title="REP 1" lazy testid="ba-horizontal" />
                </div>
              </div>
            </figure>
          </div>
        </Reveal>

        {/* GROUP 2 — VERTICAL / REEL */}
        <Reveal className="mx-auto mt-16 max-w-2xl" delay={0.05}>
          <p className="mb-4 text-center text-sm font-semibold uppercase tracking-[0.16em] text-re-muted">{t("beforeAfter.verticalReels")}</p>
          <div className="mx-auto grid max-w-sm grid-cols-1 gap-6 sm:max-w-lg sm:grid-cols-2 sm:gap-6">
            <figure className="relative overflow-hidden rounded-3xl border border-re-line bg-white shadow-premium">
              <Label>{t("beforeAfter.before")}</Label>
              <div className="aspect-[9/16] w-full">
                <img src="/example-vertical.webp" alt="" loading="lazy" className="h-full w-full object-cover object-center" />
              </div>
            </figure>
            <figure className="group/na relative">
              <div className="pointer-events-none absolute -inset-3 rounded-[2rem] bg-gradient-red opacity-[0.12] blur-2xl" />
              <div className="relative overflow-hidden rounded-3xl border border-re-line bg-white shadow-premium">
                <Label accent>{t("beforeAfter.after")}</Label>
                <div className="marketing-video-frame marketing-video-frame--vertical">
                  <VimeoPlayer videoId="1218312223" title="REP 2" lazy testid="ba-vertical" />
                </div>
              </div>
            </figure>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
